<script setup lang="ts">
import {ChevronRight} from "@lucide/vue";

const {prefixName = true} = defineProps<{
    logoPath?: string;
    name: string;
    prefixName?: boolean;
}>();
</script>

<template>
  <div class="bg-white border-primary hover:border-primary/50 border-[1.5px] flex rounded-lg overflow-hidden items-center cursor-pointer">
    <div class="h-16 w-16">
      <div v-if="$slots['logo']" class="shrink-0">
        <slot name="logo" />
      </div>
      <div v-if="logoPath && !$slots['logo']" class="shrink-0">
        <img :src="logoPath" class="h-16 w-16 object-contain" alt="logo">
      </div>
    </div>
    <div class="p-2 text-primary flex flex-1 items-center">
      <p class="flex-1">
        {{ prefixName ? `Les modules ${name}` : name }}
      </p>
      <ChevronRight class="text-gray-300 shrink-0 w-6" />
    </div>
  </div>
</template>

<style scoped>

</style>
